import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 12px;\n  position: absolute;\n  right: 16px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  & input {\n    padding: 0 16px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from '../../utils/styling/styled-components';
import { BaseTextInputV3 } from './BaseTextInputV3';
var StyledTextInput = styled(BaseTextInputV3)(_templateObject());
var CharCounter = styled.div(_templateObject2(), function (props) {
  return props.theme.colors.slate;
});

var CharCounterTextInputV3 = function CharCounterTextInputV3(_ref) {
  var error = _ref.error,
      errorText = _ref.errorText,
      label = _ref.label,
      inputProps = _ref.inputProps,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(StyledTextInput, {
    className: className,
    adornments: {
      right: /*#__PURE__*/React.createElement(CharCounter, null, inputProps.value.length)
    },
    error: error,
    errorText: errorText,
    inputProps: _objectSpread(_objectSpread({}, inputProps), {}, {
      type: 'text'
    }),
    label: label
  });
};

export { CharCounterTextInputV3 };